// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11A3r","colBig":"styles_colBig__1VvOD","colSmall":"styles_colSmall__20y9C"};